
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//     Runtime Version: 4.0.30319.42000
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export default class ReportingErrorMessages {
    static readonly firstName: string = "A First Name Is Required";
    static readonly lastName: string = "A Last Name Is Required";
    static readonly signature: string = "A Valid Signature Is Required";
    static readonly phone: string = "A Phone Number Is Required";
    static readonly email: string = "A Valid Email Is Required";
    static readonly address: string = "Address In Error";
    static readonly companyName: string = "A Company Name Is Required";
    static readonly facilityName: string = "A Facility Name Is Required";
    static readonly facilityAddress: string = "Facility Address In Error";
    static readonly facilityContact: string = "Facility Contact In Error";
    static readonly reportingPeriod: string = "A Reporting Period Is Required";
    static readonly materials: string = "Materials In Error";
    static readonly materialItemName: string = "A Name Is Required";
    static readonly materialItemOverrideName: string = "An Override Name Is Required";
    static readonly materialItemAmount: string = "An Amount Is Required";
    static readonly materialWholeNumber: string = "Material Amount Must Be A Whole Number";
    static readonly materialItemMeasure: string = "A Unit Of Measure Is Required";
    static readonly volume: string = "A Valid Volume Is Required";
    static readonly volumeReclaimed: string = "Volume Reclaimed Is Invalid";
    static readonly generatorStatus: string = "A Liquid Waste Generator Status Is Required";
    static readonly generatorId: string = "A Liquid Waster Generator Id Is Required";
    static readonly cookCountyRegion: string = "A Cook County Region Is Required";
    static readonly haulerName: string = "A Hauler Name Is Required";
    static readonly nonResidentialSiteCount: string = "Estimated Sites In Region Required";
    static readonly nonResidentialSitesServiced: string = "Percentage Of Sites Serviced Required";
    static readonly recyclingClass: string = "A Recycling Class Is Required";
    static readonly recyclableMaterials: string = "Recyclable Materials In Error";
    static readonly nonRecyclableMaterials: string = "Non-Recyclable Materials In Error";
    static readonly municipality: string = "A Municipality Is Required";
    static readonly householdsServiced: string = "# Of Households Serviced Is Required";
    static readonly householdsProvidedRecycling: string = "# Of Households Provided Is Required";
    static readonly householdsProvidedYardWaste: string = "# Of Households Provided Is Required";
    static readonly materialWeightReceived: string = "Material Weight Received Is Required";
    static readonly materialWeightRemoved: string = "Material Weight Removed Value Is Invalid";
}